import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateFormTemplateMutation } from '../../../../hooks/mutations/useFormTemplateMutation';
import { useFormTypesQuery } from '../../../../hooks/queries/useFormTypesQuery';
import CustomTextInput from '../../../CustomTextInput';
import DropDown, { OptionType } from '../../../DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';
import { useNavigate } from 'react-router-dom';

interface CreateFormModalProps extends ModalProps {
    refetch?: () => void;
}

const CreateFormModal: React.FC<CreateFormModalProps> = ({ open, handleClose, refetch = () => {} }) => {
    const [selectedFormType, setSelectedFormType] = useState<OptionType | null>(null);
    const [formTitle, setFormTitle] = useState('');

    const navigate = useNavigate();

    const { t } = useTranslation();

    const { data: dataFormTypes, isLoading: isFormTypesLoading } = useFormTypesQuery({ queries: { active: true } });
    const { mutate: createFormTemplate } = useCreateFormTemplateMutation({
        onSuccess: (data) => {
            navigate(`/qhse/forms/${data.data._id}`);
            refetch();
        },
    });

    return (
        <ModalBody
            closeText={t('cancel')}
            okText={t('create')}
            title={t('form')}
            subTitle={t('create')}
            open={open}
            handleClose={handleClose}
            handleOk={() => {
                createFormTemplate({ title: formTitle, typeId: selectedFormType?.value || '' });
            }}
            disabledOk={!formTitle.length || !selectedFormType}
        >
            <CustomTextInput value={formTitle} onChange={(text) => setFormTitle(text)} label={t('title')} required />
            <DropDown
                selectedItem={selectedFormType}
                items={
                    dataFormTypes?.map((formType) => ({
                        label: formType.designation,
                        value: formType._id,
                    })) || []
                }
                handleChange={(event, value) => setSelectedFormType({ value: value?.value || '', label: value?.label || '' })}
                inputLabel={t('formType')}
                loading={isFormTypesLoading}
                required
            />
        </ModalBody>
    );
};

export default CreateFormModal;
